module.exports = __webpack_public_path__ + "img/8seater.a77095af.png";